<h1 mat-dialog-title>{{ 'Registro/modificación de desviación' | translate }}</h1>
<form>


  <div mat-dialog-content class="qualificates-theme registro-deviacion" fxLayout="column">

    <div fxLayout="row" fxLayoutAlign="start center">
      @if (data?.protocolNumber) {
        <mat-form-field fxFlex="45%">
          <mat-label>{{'executionEditQ.deviation.protocol.label' | translate}}</mat-label>
          <input matInput [ngModel]="data.protocolNumber" [disabled]="true" name="protocolNumber" [ngModelOptions]="{standalone: true}">
        </mat-form-field>
      }
      @if (data.deviation?.codeDeviation) {
        <mat-form-field fxFlex="45%">
          <mat-label>{{'executionEditQ.deviation.nDesviation.label' | translate}}</mat-label>
          <input matInput [ngModel]="data.deviation.codeDeviation" [disabled]="true" name="codeDeviation" [ngModelOptions]="{standalone: true}">
        </mat-form-field>
      }
    </div>

    <div fxLayout="column">
      <mat-form-field fxFlex>
        <mat-label>{{'executionEditQ.deviation.description.label' | translate}}</mat-label>
        <textarea matInput rows="5" [(ngModel)]="commentsDeviation.comments" [ngModelOptions]="{standalone: true}"
          name="commentsDeviation"
        [placeholder]="'executionEditQ.deviation.description.placeholder' | translate"></textarea>
      </mat-form-field>
    </div>


    <div class="evaluacion" fxLayout="column">
      <div fxLayout="row" fxLayoutAlign="space-between center">
        <div>
          <span>{{'executionEditQ.deviation.valuation.label' | translate}}:</span>
          <mat-radio-group [(ngModel)]="evaluation.valuation" name="valuation" [ngModelOptions]="{standalone: true}">
            <mat-radio-button class="mat-deviation-radio-label-content" [value]="1"> {{'Crítica' |
            translate}} </mat-radio-button>
            <mat-radio-button class="mat-deviation-radio-label-content" [value]="2"> {{'Mayor' | translate}}
            </mat-radio-button>
            <mat-radio-button class="mat-deviation-radio-label-content" [value]="3"> {{'Menor' | translate}}
            </mat-radio-button>
          </mat-radio-group>
        </div>
        <div>
          <span>{{'executionEditQ.deviation.continue.label' | translate}}:</span>
          <mat-radio-group [(ngModel)]="evaluation.qualificationContinue" name="qualificationContinue"  [ngModelOptions]="{standalone: true}">
            <mat-radio-button class="mat-deviation-radio-label-content" [value]="true"> {{'common.yes' |
            translate}} </mat-radio-button>
            <mat-radio-button class="mat-deviation-radio-label-content" [value]="false"> {{'common.no' |
            translate}} </mat-radio-button>
          </mat-radio-group>
        </div>
      </div>
      <mat-form-field fxFlex>
        <mat-label>{{'executionEditQ.deviation.valuation.label' | translate}}</mat-label>
        <textarea matInput rows="3" [(ngModel)]="evaluation.comments" name="evaluationComments" [ngModelOptions]="{standalone: true}"
        [placeholder]="'executionEditQ.deviation.valuation.placeholder' | translate"></textarea>
      </mat-form-field>
    </div>

    @if (!seeMore) {
      <div mat-dialog-actions class="qualificates-theme">
        <button mat-raised-button color="accent" (click)="changeSeeMore()">{{ 'button.seeMore' | translate
        }}</button>
      </div>
    }
    @if (seeMore) {
      <div>
        <div fxLayout="column">
          <mat-form-field fxFlex>
            <mat-label>{{'executionEditQ.deviation.corrective.actions.label'|translate}}</mat-label>
            <textarea matInput rows="5" [(ngModel)]="proposedCorrective.comments" name="proposedCorrective"
              [ngModelOptions]="{standalone: true}"
            [placeholder]="'executionEditQ.deviation.corrective.actions.placeholder' | translate"></textarea>
          </mat-form-field>
        </div>
        <div fxLayout="column">
          <mat-form-field fxFlex>
            <mat-label>{{'executionEditQ.deviation.actions.taken.label' | translate}}</mat-label>
            <textarea matInput rows="5" [(ngModel)]="actionsTaken.comments" name="actionsTaken"
              [ngModelOptions]="{standalone: true}"
            [placeholder]="'executionEditQ.deviation.actions.taken.placeholder' | translate"></textarea>
          </mat-form-field>
        </div>
        <div class="evaluacion" fxLayout="column">
          <div fxLayout="row" fxLayoutAlign="space-between center">
            <div>
              <span>{{'executionEditQ.deviation.result.deviation.label' | translate}}:</span>
              <mat-radio-group [(ngModel)]="deviationResolution.resolved" name="resolvedDesviation">
                <mat-radio-button class="mat-deviation-radio-label-content" [value]="true"> {{'common.yes' |
                translate}} </mat-radio-button>
                <mat-radio-button class="mat-deviation-radio-label-content" [value]="false"> {{'common.no' |
                translate}} </mat-radio-button>
              </mat-radio-group>
            </div>
          </div>
          <mat-form-field fxFlex>
            <mat-label>{{'executionEditQ.deviation.resolution.comments.label' | translate}}</mat-label>
            <textarea matInput rows="3" [(ngModel)]="deviationResolution.comments" [ngModelOptions]="{standalone: true}"
              name="deviationResolution"
            [placeholder]="'executionEditQ.deviation.resolution.comments.placeholder' | translate"></textarea>
          </mat-form-field>
        </div>
        <!--<div class="evaluacion" fxLayout="column">
        <div fxLayout="row" fxLayoutAlign="space-between center">
          <div>
            <span>{{'executionEditQ.deviation.closed.label' | translate}}:</span>
            <mat-radio-group [(ngModel)]="closedDeviation.closed" name="closeDesviation">
              <mat-radio-button class="mat-deviation-radio-label-content" [value]="true"> {{'common.yes' |
              translate}} </mat-radio-button>
              <mat-radio-button class="mat-deviation-radio-label-content" [value]="false"> {{'common.no' |
              translate}} </mat-radio-button>
            </mat-radio-group>
          </div>
        </div>
      </div>-->
      @if (seeMore) {
        <div mat-dialog-actions class="qualificates-theme">
          <button mat-raised-button color="accent" (click)="changeSeeMore()">{{ 'button.seeLess' | translate
          }}</button>
        </div>
      }
    </div>
  }
</div>

<div mat-dialog-actions class="qualificates-theme">
  <div fxFlex></div>
  @if (data.deviation?.id && !data.deviation?.idAttachment) {
    <button mat-raised-button color="accent"
    (click)="fileInput.click()">{{ 'executionAuditAction.uploadAttachment' | translate }}</button>
  }
  <input type="file" #fileInput (change)="uploadAttachment($event)" hidden />
  @if (data.deviation?.id && !data.deviation?.idAttachment) {
    <div fxFlex="5px"></div>
  }
  @if (data.deviation?.idAttachment) {
    <button mat-raised-button color="accent"
      (click)="downloadAttachment(data.deviation.idAttachment)">{{ 'button.download_attachment' | translate
    }}</button>
  }
  <div fxFlex="5px"></div>
  @if (data.deviation?.idAttachment) {
    <button mat-raised-button color="accent"
      (click)="deleteAttachment(data.deviation.idAttachment, data.deviation.id)">{{ 'button.delete_attachment' |
    translate }}</button>
  }
  <div fxFlex="5px"></div>
  @if (data.deviation?.id) {
    <button mat-raised-button color="primary" (click)="downloadDeviation()">{{
    'button.deviationDownload' | translate }}</button>
  }
  <div fxFlex="5px"></div>
  <button mat-raised-button color="primary" (click)="onOkClick()">{{ 'button.save' | translate }}</button>
  <div fxFlex="5px"></div>
  <button mat-raised-button color="secondary" (click)="onNoClick()">{{ 'button.cancel' | translate }}</button>
</div>
</form>